import React, { useEffect, useRef, useId } from 'react';
import UserAvatar from './UserAvatar';
import { Mail, X } from 'lucide-react';

const UserCard = ({ user, onClose }) => {
    const closeRef = useRef(null);
    const titleId = useId();

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && onClose) {
                onClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // Focus close button for accessibility
        const timer = setTimeout(() => {
            closeRef.current?.focus();
        }, 50);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            clearTimeout(timer);
        };
    }, [onClose]);

    if (!user) return null;

    return (
        <div
            className="fixed inset-0 bg-black/60 z-[1050] flex justify-center items-center p-4 animate-fade-in"
            onClick={onClose}
        >
            <div
                className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl w-full max-w-sm transform transition-all duration-300 ease-in-out scale-100"
                onClick={e => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
            >
                <div className="relative p-6">
                    <button
                        ref={closeRef}
                        onClick={onClose}
                        className="absolute top-3 right-3 p-1.5 rounded-full text-slate-500 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400"
                        aria-label="Fechar"
                    >
                        <X size={20} />
                    </button>

                    <div className="flex flex-col items-center">
                        <div className="mb-4">
                            {/* Corrigido tamanho do avatar para classes válidas do Tailwind (h-32 w-32 = 128px) */}
                            <UserAvatar user={user} size="h-32 w-32" />
                        </div>

                        <h2 id={titleId} className="text-2xl font-bold text-slate-800 dark:text-slate-100">
                            {user.displayName || 'Nome não disponível'}
                        </h2>

                        {user.email && (
                            <div className="flex items-center text-slate-500 dark:text-slate-400 mt-2">
                                <Mail size={16} className="mr-2" />
                                <a
                                    href={`mailto:${user.email}`}
                                    className="hover:underline focus:outline-none focus:ring-2 focus:ring-slate-400 rounded-sm"
                                >
                                    {user.email}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserCard;
